// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import {useCallback, useEffect, useRef, useState} from 'react';
import etask from 'zetask';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {t_screen, use_screen} from '../../lib/screen_util';
import {use_pathname} from '../../lib/use_pathname';

const DEFAULT_PER_PAGE = 9;

interface i_use_fetch_posts_props {
    container: HTMLElement;
    posts_url: string;
    min_delay?: number;
    load_gap?: number;
    per_page?: Partial<Record<t_screen|'all', number>>;
    category?: string;
    paged?: string | number;
    load_on_scroll?: boolean;
    on_load_more: (page: any)=>void;
}
export const use_fetch_posts = (props: i_use_fetch_posts_props)=>{
    const {container, posts_url, min_delay = 0, load_gap = 0,
        on_load_more, per_page = {} as i_use_fetch_posts_props['per_page'],
        category = '', paged, load_on_scroll} = props;
    const {height, screen} = use_screen();
    const [is_loading, set_is_loading] = useState(false);
    const fetching = useRef<boolean>(false);
    const current_page = useRef<number>(Number(paged) || 1);
    const process = useRef<any>();
    const total_pages = useRef(null);
    const {params} = use_pathname();
    const resolve_per_page = params.per_page||per_page[screen]||per_page.all
        ||DEFAULT_PER_PAGE;
    const fetch_posts = useCallback(()=>{
        set_is_loading(true);
        fetching.current = true;
        current_page.current = Number(paged) || current_page.current + 1;
        process.current = etask(function*(){
            yield etask.sleep(min_delay);
            const page = yield fetch(`${posts_url}?`+
                `posts_per_page=${resolve_per_page}`+
                `&paged=${current_page.current}${category ?
                `&category=${category}` : ''}`);
            total_pages.current = page.total_pages;
            fetching.current = false;
            on_load_more(page);
            set_is_loading(false);
        });
    }, [on_load_more, resolve_per_page, posts_url, min_delay]);
    const abort = useCallback(()=>{
        process.current && process.current.return();
        set_is_loading(false);
    }, []);
    useEffect(()=>{
        if (paged)
        {
            abort();
            fetch_posts();
        }
    }, [paged]);
    useEffect(()=>{
        const on_scroll_listener = ()=>{
            if (!load_on_scroll || !container || fetching.current ||
                current_page.current == total_pages.current)
            {
                return;
            }
            const container_height = container.scrollHeight;
            const scroll_top = document.documentElement.scrollTop;
            const need_fetch = load_gap
                ? height - container.getBoundingClientRect().bottom > load_gap
                : scroll_top > container_height - height;
            if (need_fetch)
                fetch_posts();
        };
        window.addEventListener('scroll', on_scroll_listener);
        return ()=>{
            abort();
            window.removeEventListener('scroll', on_scroll_listener);
        };
    }, [load_on_scroll, container, category]);
    return {is_loading, fetch_posts, abort};
};
